import { Typography } from "@/components";
import type { Reminder } from "@/types";
import InfoIcon from "@mui/icons-material/Info";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Radio from "@mui/material/Radio";
import dayjs from "dayjs";

interface ReminderCardProps {
	reminder: Reminder;
	onClickRadio: (
		e: React.MouseEvent<HTMLButtonElement>,
		reminderId: number,
		is_done: boolean,
	) => void;
}

const ReminderCard = (props: ReminderCardProps) => {
	const { reminder, onClickRadio } = props;
	return (
		<Card variant="outlined" className="w-full h-full !rounded-xl !shadow-sm">
			<CardContent className="!px-3 !py-2 flex gap-2 h-20 items-start">
				<Radio
					value={reminder.id}
					checked={reminder.is_done}
					aria-label={reminder.name}
					onClick={(e) => onClickRadio(e, reminder.id, reminder.is_done)}
				/>
				<div className="h-full flex flex-col flex-1 gap-2 justify-center">
					<Typography fontWeight={500} fontSize={14}>
						{reminder.name}
					</Typography>
					<div className="flex items-center gap-2">
						<NotificationsOutlinedIcon fontSize="small" />
						<Typography fontWeight={400} fontSize={12}>
							{reminder.alarm
								? dayjs(reminder.alarm).format("DD MMM YYYY, HH:mm A")
								: "Set Date & Time"}
						</Typography>
						{reminder.repeat && reminder.repeat !== "Never" ? (
							<>
								<ReplayIcon fontSize="small" />
								<Typography fontWeight={400} fontSize={12}>
									{reminder.repeat}
								</Typography>
							</>
						) : null}
					</div>
				</div>
				<InfoIcon />
			</CardContent>
		</Card>
	);
};

export default ReminderCard;
